import { entities } from '@toggle/toggle';

import { apiFetch } from '~/utils/api-fetch/apiFetch';

import { EntityTags } from './watchlist-types';

export const resolveEntitiesFromCsv = async (
  tagsCsv: string
): Promise<string[]> => {
  const res = await apiFetch<EntityTags>(entities.resolveFromCsv.path, {
    method: 'post',
    body: {
      csv: tagsCsv,
    },
  });

  if (res.error) {
    return [];
  }

  const uniqueTags = [...new Set(res.data.tags)];

  if (!uniqueTags.length) {
    return [];
  }

  return uniqueTags;
};
